// extracted by mini-css-extract-plugin
module.exports = {"view":"_2q8RQKgWwHkctbiBM_6nmZ"};